import React from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';

import ActiveChip from 'components/Common/ActiveChip';
import getCertifictionStatus from 'common/Forms/CertificationStatus';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import RelationshipType from 'common/Customers/RelationshipType';
import RelationshipTypeFrom from 'common/Customers/RelationshipTypeFrom';

const CustomerLinkList = ({ customer, onConfirmLinkRemove }) => {
  const getGroupedCustomerLinksList = ({ links = [], linksFrom = [] }) => {
    const taggedLinks = [
      ...(links ?? []).map(link => ({ ...link,
        direction: 'out',
        isActive: link.toCustomer.isActive,
        dbIdOfLinkedCustomer: link.toCustomerId,
        custIdOfLinkedCustomer: link.toCustomer.customerId,
        name: link.toCustomer.name,
        certificationStatusDescription: link.toCustomer.certificationStatusDescription,
        certificationStatus: link.toCustomer.certificationStatus })),
      ...(linksFrom ?? []).map(link => ({ ...link,
        direction: 'from',
        isActive: link.fromCustomer.isActive,
        dbIdOfLinkedCustomer: link.fromCustomerId,
        custIdOfLinkedCustomer: link.fromCustomer.customerId,
        name: link.fromCustomer.name,
        certificationStatusDescription: link.fromCustomer.certificationStatusDescription,
        certificationStatus: link.fromCustomer.certificationStatus }))
    ];

    const sortedList = taggedLinks?.sort((a, b) => {
      if (moment(b.effectiveTo).isSame(a.effectiveTo)) {
        return moment(b.effectiveFrom).isAfter(a.effectiveFrom) ? 1 : -1;
      }
      return moment(b.effectiveTo).isAfter(a.effectiveTo) ? 1 : -1;
    });

    const grouped = sortedList?.reduce((linkCollection, currentLink) => {
      const key = `f${ currentLink.id }`;
      if (!linkCollection.keys[key]) {
        linkCollection.keys[key] = linkCollection.values.length + 1;
        linkCollection.values.push(currentLink);
        linkCollection.key = key;
      }

      return linkCollection;
    }, { keys: {}, values: [] });

    return grouped?.values.sort((a, b) => (a.custIdOfLinkedCustomer > b.custIdOfLinkedCustomer ? -1 : 1));
  };

  return (
    <div>
      <table className="table table-striped-groups table-hover table-bordered forms-list" id="customer-links-table">
        <thead>
          <tr>
            <th>Effective From</th>
            <th>Effective To</th>
            <th>Customer ID</th>
            <th>Customer Name</th>
            <th>Customer Status</th>
            <th>Relationship</th>
            <th>Certification Status</th>
            <AccessControl allowedPermissions={ [ActivityPerms.customerEdit] }>
              <th>Unlink</th>
            </AccessControl>
          </tr>
        </thead>
        { (customer != null
        && (
          (customer.links != null && customer.links.length > 0)
          || (customer.linksFrom != null && customer.linksFrom.length > 0)
        ))
          && getGroupedCustomerLinksList(customer).map(linkData => linkData != null && <tbody>
            <tr key={ linkData.key } className="br-1 form-row">
              <td align="center">{linkData.effectiveFrom ? moment(linkData.effectiveFrom).format('MMM DD, YYYY') : 'N/A'}</td>
              <td align="center">{linkData.effectiveTo ? moment(linkData.effectiveTo).format('MMM DD, YYYY') : 'N/A'}</td>
              <td align="center"><a href={ `/customer/${ linkData.dbIdOfLinkedCustomer }` }>{ linkData.custIdOfLinkedCustomer }</a></td>
              <td align="center">{ linkData.name }</td>
              <td align="center"><ActiveChip isActive={ linkData.isActive } /></td>
              <td align="center">{ (linkData.direction === 'out' ? RelationshipType.find(r => r.value === linkData.relationshipType)
                : RelationshipTypeFrom.find(r => r.value === linkData.relationshipType)
              )?.name || 'Unknown'}</td>
              <td align="center">{ getCertifictionStatus(linkData.certificationStatus) }</td>
              <AccessControl allowedPermissions={ [ActivityPerms.customerEdit] }>
                <td align="center">
                  <button
                    type="submit"
                    className="btn btn-sm btn-danger"
                    onClick={ () => onConfirmLinkRemove(linkData.id) }
                  >
                    <span className="icon icon-link" />
                  </button>
                </td>
              </AccessControl>
            </tr>
          </tbody>) }
        { (!customer
        || (
          (!customer.links || customer.links.length === 0)
          && (!customer.linksFrom || customer.linksFrom.length === 0))
        )
          && <tbody><tr><td colSpan="9" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr></tbody> }
      </table>
    </div>
  );
};

CustomerLinkList.propTypes = {
  customer: PropTypes.shape(),
  onConfirmLinkRemove: PropTypes.func.isRequired,
};

CustomerLinkList.defaultProps = {
  customer: {
    Links: []
  }
};

export default CustomerLinkList;
